import { useEffect, useState } from 'react';
import { MdSignalWifiConnectedNoInternet1 } from 'react-icons/md';

const InternetStatusModal = () => {
  const [isOnline, setIsOnline] = useState(true);
  const url = import.meta.env.VITE_API_URL_KEY || "";


  const checkOnlineStatus = async () => {
    try {
      const res = await fetch(`${url}/ok`);
      setIsOnline(true);
    } catch (err) {
      setIsOnline(false);
    }
  };

  useEffect(() => {
    checkOnlineStatus();
    const intervalId = setInterval(checkOnlineStatus, 5000);
    return () => clearInterval(intervalId);
  }, []);

  if (isOnline) {
    return false;
  }

  return (
    <div className='internet-connection-modal'>
      <div className='internet-connection-modal-body py-4'>
        <div className='d-flex flex-column justify-content-center gap-3'>
          <div className='text-center'>
            <MdSignalWifiConnectedNoInternet1 size={70} color='#0533B3' />
          </div>
          <h2 className='text-center'>No Internet Connection</h2>

          <p className='text-muted text-center'>
            Please check your connection. We couldn't detect an active internet connection.
          </p>
          <div className='d-flex gap-1 justify-content-center'>
            <p className='text-muted text-center'>
              Waiting for connection
            </p>
            <div className='internet-connection-loader mb-2'></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InternetStatusModal;
